import React from "react";
import { FaCopy, FaEnvelope, FaPhone, FaPaypal, FaTimes, FaWhatsapp } from "react-icons/fa";
import { DoctorType } from "./types";

interface SlotType {
  id: number;
  datetime: string;
}

interface BookingReceiptModalProps {
  totalCost: number;
  showBookingId: string;
  selectedDoctor: number | null;
  selectedSlots: { [date: string]: SlotType[] };
  filteredDoctorsData: DoctorType[];
  closeModal: () => void;
  copyToClipboard: (text: string) => void;
  sendEmail: () => void;
}

const BookingReceiptModal: React.FC<BookingReceiptModalProps> = ({
  totalCost,
  showBookingId,
  selectedDoctor,
  selectedSlots,
  filteredDoctorsData,
  closeModal,
  copyToClipboard,
  sendEmail,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full max-h-90vh overflow-y-auto relative">
        <button
          onClick={closeModal}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          <FaTimes size={24} />
        </button>
        <h4 className="text-xl text-gray-800 mb-4 text-center">Booking Receipt</h4>
        <div className="mb-4 pb-4 border-b border-gray-200">
          <p className="text-lg font-bold text-gray-900 mb-1">Booking ID: {showBookingId}</p>
          <p className="text-sm text-gray-600">Date: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="mb-4">
          <h5 className="font-semibold text-gray-800 mb-2">Appointment Details</h5>
          <p className="text-sm text-gray-600">
            Doctor: {filteredDoctorsData.find((doctor) => doctor.id === selectedDoctor)?.therapist.name}
          </p>
          {Object.entries(selectedSlots).map(([date, slots]) => (
            <div key={date}>
              <p className="text-sm text-gray-600">Date: {date}</p>
              <p className="text-sm text-gray-600 mb-2">
                Time: {slots.map((slot) => {
                  const slotDateTime = new Date(slot.datetime);
                  return slotDateTime.toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  });
                }).join(', ')}
              </p>
            </div>
          ))}
        </div>
        <div className="mb-6 pb-4 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <span className="font-semibold text-gray-800">Total Amount:</span>
            <span className="font-bold text-lg text-green-600">£{totalCost}</span>
          </div>
        </div>
        <div className="bg-gray-50 p-4 rounded-md mb-4">
          <h5 className="font-semibold text-gray-800 mb-2">Payment Instructions</h5>
          <p className="text-sm text-gray-600 mb-2">Please deposit the total amount to the following bank account:</p>
          <div className="bg-white p-3 rounded-md shadow-sm">
            {/* {
              Account Holder Name : JAYALAKSHMI NATARAJAN
              Account number : 923010036428752
              IFSC Code : UTIB0001511
            } */}
            <p className="text-sm text-gray-700">Account Holder Name: JAYALAKSHMI NATARAJAN</p>
            <p className="text-sm text-gray-700 flex items-center justify-between">
              Account Number: 923010036428752
              <button onClick={() => copyToClipboard("923010036428752")} className="text-blue-500 hover:text-blue-700">
                <FaCopy />
              </button>
            </p>
            <p className="text-sm text-gray-700 flex items-center justify-between">
            IFSC Code : UTIB0001511
              <button onClick={() => copyToClipboard("UTIB0001511")} className="text-blue-500 hover:text-blue-700">
                <FaCopy />
              </button>
            </p>
            <p className="text-sm text-gray-700">Bank Name: AXIS BANK, Perambur, Chennai</p>
            
          </div>
          
        </div>
        <div className="flex flex-col space-y-2">
          <a 
            href={`https://paypal.me/arunkarnan/${totalCost}gbp`} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center justify-center bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
          >
            <FaPaypal className="mr-2" /> Pay with PayPal
          </a>

          <p className="text-sm text-gray-600">Submit the payment and email us the payment confirmation to confirm your booking.</p>
          <button
            onClick={sendEmail}
            className="flex items-center justify-center bg-white text-black px-4 py-2 rounded hover:bg-blue-600 transition-colors border "
          >
            <FaEnvelope className="mr-2" /> Email Payment Confirmation
          </button>
          <a
            href="https://wa.me/916374480026"
            className="flex items-center justify-center bg-white text-black px-4 py-2 rounded hover:bg-green-600 transition-colors border"
          >
            <FaWhatsapp className="mr-2" /> WhatsApp Payment Confirmation
          </a>
        </div>
      </div>
    </div>
  );
};

export default BookingReceiptModal;